<template>
    <form id="onboarding-de" class="wrapper" role="form" method="post">
        <header>
            <span class="headline-xlg">Erzählen Sie uns etwas über sich</span>
        </header>

        <div v-for="slider in sliders" class="input-wrapper wrapper-range">
            <div class="range-text">
                <strong>{{ slider.title }}</strong>
                <div class="range-output">
                    <input :class="'input-range-'+slider.id" type="number" placeholder="0" :value="slider.value > 0 ? slider.value : null">
                    <strong class="range-unit headline-xs">{{ slider.unit }}</strong>
                </div>
            </div>
            <input :id="slider.id" :class="'input-range range-'+slider.id" type="range" :min="slider.min" :max="slider.max" step="1" :value="slider.value" data-rangeslider>
        
            <form-input-error v-if="slider.error" :error="slider.error"></form-input-error>
        </div>

        <v-button label="Weiter" size="lg" full-width @onClick="onClickButton()"></v-button>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                isDisabled: true,
                sliders: [
                    {
                        id: 'age',
                        min: 18,
                        max: 90,
                        unit: 'Jahre',
                        title: 'Alter',
                        value: 0,
                        error: null
                    },
                    {
                        id: 'height',
                        min: 140,
                        max: 220,
                        unit: 'cm',
                        title: 'Größe',
                        value: 0,
                        error: null
                    },
                    {
                        id: 'weight',
                        min: 40,
                        max: 250,
                        unit: 'kg',
                        title: 'Gewicht',
                        value: 0,
                        error: null
                    }
                ]
            }
        },

        mounted() {
            var that = this

            this.sliders.forEach(slider => {
                $('.range-'+slider.id).rangeslider({
                    polyfill: false,
                    onSlide: function(position, value) {
                        slider.value = value
                        slider.error = false
                    }
                })

                $('.input-range-'+slider.id).on('change', function() {
                    var value = $(this).val()

                    if(value >= slider.min && value <= slider.max) {
                        $('.range-'+slider.id).val(value).change()
                    } else {
                        slider.error = 'Der eingegebene Wert muss zwischen '+slider.min+' - '+slider.max+' '+slider.unit+' liegen.'
                    }
                })
            })
        },

        methods: {
            onClickButton () {
                this.validate()

                if(!this.isDisabled) {
                    this.$emit('clicked', {age: this.sliders[0].value, height: this.sliders[1].value, weight: this.sliders[2].value})
                }
            },
            validate() {
                var that = this

                for(let slider of this.sliders) {
                    if(slider.value < slider.min || slider.value > slider.max) {
                        slider.error = 'Der eingegebene Wert muss zwischen '+slider.min+' - '+slider.max+' '+slider.unit+' liegen.'
                    }
                }

                for(let slider of this.sliders) {
                    if(slider.value >= slider.min && slider.value <= slider.max) {
                        that.isDisabled = false
                        slider.error = null
                    } else {
                        that.isDisabled = true
                        break
                    }
                }
            }
        }
    }
</script>